import { Injectable, inject } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';
import { User } from '@domain/models';
import { UserRepositoryPort } from '@domain/ports';
import { httpUrl } from '@shared/runtime-config';

@Injectable({ providedIn: 'root' })
export class HttpUserRepository extends UserRepositoryPort {
  private readonly http = inject(HttpClient);
  private readonly base = `${httpUrl('whatsapp')}/api/v1/users`;

  list(): Observable<User[]> {
    return this.http.get<User[]>(this.base);
  }

  getCurrent(): Observable<User | null> {
    return this.http.get<User>(`${this.base}/me`).pipe(
      catchError((err: HttpErrorResponse) =>
        err.status === 404 ? of(null) : throwError(() => err))
    );
  }

  getById(id: string): Observable<User | null> {
    return this.http.get<User>(`${this.base}/${id}`).pipe(
      catchError((err: HttpErrorResponse) =>
        err.status === 404 ? of(null) : throwError(() => err))
    );
  }

  getByPhone(phoneNumber: string): Observable<User | null> {
    const params = new HttpParams().set('phone', phoneNumber);
    return this.http.get<User>(`${this.base}/by-phone`, { params }).pipe(
      catchError((err: HttpErrorResponse) =>
        err.status === 404 ? of(null) : throwError(() => err))
    );
  }
}
